import React from 'react';
import classNames from 'classnames';
import { COLOR_VARIANT, ColorVariants } from 'models/Colors';

import './RoleTag.styles.scss';

type RoleTagProps = {
  className?: string;
  variant?: ColorVariants;
  onClick?: () => void;
};

const RoleTag: React.FC<RoleTagProps> = (props) => {
  const {
    children,
    className,
    variant = COLOR_VARIANT.SILVER,
    onClick,
  } = props;

  const classes = classNames(
    'role-tag',
    variant,
    { clickable: !!onClick },
    className,
  );

  return (
    <p className={classes} onClick={onClick}>
      {children}
    </p>
  );
};

export default RoleTag;
